import { createListCollection } from "@chakra-ui/react"

export default createListCollection({
  items: [
    { label: "Cash", value: 2 },
    { label: "Finance", value: 3 },
    { label: "Auction", value: 4 },
    { label: "BHPH", value: 5 },
    { label: "Wholesale", value: 6 }
  ]
})

export const employeeSaleOptions = createListCollection({
  items: [
    { label: "Cash", value: 2 },
    { label: "Auction", value: 4 },
  ]
})